<template>
  <view class="search-container">
    <image  class="search-icon" src="https://ut-static.udache.com/webx/sfc/4ejT4H0V2xrEnrMA0wM0_.png"/>
    <input type="text" value="{{keywords}}" class="search" placeholder="{{placeholder}}" bindinput="search"/>
    <view class="clear" bindtap="clear" wx:show="{{keywords}}">
      <image class="clear-icon" src="https://dpubstatic.udache.com/static/dpubimg/oXTzcUM0JPGZ6UAQybX26.png" />
    </view>
  </view>
</template>

<script>
 import { createComponent } from '@mpxjs/core'

  createComponent({
    data: {
      keywords: '',
      timer: null
    },
    props: {
      placeholder: {
        type: String,
        value: '选择出发地／选择目的地'
      },
      debounceTime: {
        type: Number,
        value: 300
      }
    },
    methods: {
      /**
       * @description: 输入
       */
      search({ detail }) {
        const keyword = detail.value.trim()
        this.keywords = keyword
        clearTimeout(this.timer)

        if (!keyword) {
          this.triggerEvent('clear')
          return
        }

        this.timer = setTimeout(() => {
          this.triggerEvent('input', keyword)
        }, this.debounceTime)
      },

      clear() {
        this.keywords = ''
        this.triggerEvent('clear')
      }
    }
  })
</script>

<style scoped lang="stylus" scoped>
  .search-container
    display flex
    padding 0 16px
    align-items center
    height 45px
    background #ffffff
    position relative
    z-index 99
  .search-icon
    position absolute
    left 31px
    height 21px
    width 21px
    top 50%
    transform translateY(-50%)
  .search
    padding-left 41px
    flex 1
    height 44px
    font-size 14px
    background #F6F7F8
    border-radius 8px
    border 1px solid #1473FF
    box-sizing border-box
  .clear
    position absolute
    right 16px
    z-index 100
    margin 12px
    display flex
    align-items center
    top 0
  .clear-icon
    width 20px
    height 20px
  input::-webkit-input-placeholder
    color #666666
</style>
<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      
    }
  }
</script>
